import loginbg22 from "../../img/loginbg22.jpg";
import loginbg2 from "../../img/loginbg2.jpg";
import loginbg3 from "../../img/loginbg3.jpg";
import loginbg44 from "../../img/loginbg44.jpg";
import loginbg5 from "../../img/loginbg5.jpg";

export const loginImages = [
  { img: loginbg2, Text: "50% less chemicals since 10 years" }, // good
  { img: loginbg22, Text: "CO2  Neutral  Since 2017" },
  { img: loginbg3, Text: "ALWAYS Better social and  working conditions" },
  { img: loginbg44, Text: "100% Green Energy by 2025" },
  {
    img: loginbg5,
    Text: "close to 100% reused waste water In production by 2025 ",
  },
];
